export enum EMachineType {
	IdeaPad = 0,
	ThinkPad = 1,
	IdeaCenter = 2,
	ThinkCenter = 3,
	Desktop = 4
}
